var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#72E128"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white",
    fillOpacity: 0.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 18.9C18.53 18.31 17.8 17.7 17.8 16.75C17.8 15.66 18.81 14.9 20.5 14.9C22.28 14.9 22.94 15.75 23 17H25.21C25.14 15.28 24.09 13.7 22 13.19V11H19V13.16C17.06 13.58 15.5 14.84 15.5 16.77C15.5 19.08 17.41 20.23 20.2 20.9C22.7 21.5 23.2 22.38 23.2 23.31C23.2 24 22.71 25.1 20.5 25.1C18.44 25.1 17.63 24.18 17.52 23H15.32C15.44 25.19 17.08 26.42 19 26.83V29H22V26.85C23.95 26.48 25.5 25.35 25.5 23.3C25.5 20.46 23.07 19.49 20.8 18.9Z",
    fill: "#72E128"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 18.9C18.53 18.31 17.8 17.7 17.8 16.75C17.8 15.66 18.81 14.9 20.5 14.9C22.28 14.9 22.94 15.75 23 17H25.21C25.14 15.28 24.09 13.7 22 13.19V11H19V13.16C17.06 13.58 15.5 14.84 15.5 16.77C15.5 19.08 17.41 20.23 20.2 20.9C22.7 21.5 23.2 22.38 23.2 23.31C23.2 24 22.71 25.1 20.5 25.1C18.44 25.1 17.63 24.18 17.52 23H15.32C15.44 25.19 17.08 26.42 19 26.83V29H22V26.85C23.95 26.48 25.5 25.35 25.5 23.3C25.5 20.46 23.07 19.49 20.8 18.9Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.e6c064890a91b69ad4373b24ede3c2d8.svg";
export { ForwardRef as ReactComponent };